import type { KeywordGroupsLimits } from '@app/components/Modals/BotDetailsModal/constants/keywordGroups';

// Строка условий: значения через запятую (ИЛИ). Возвращает текст ошибки
// или null, если строка валидна.
export const getKeywordGroupError = (
  value: string | undefined,
  limits?: KeywordGroupsLimits
): string | null => {
  if (!value) return null;

  const parts = value.split(',').map((part) => part.trim());

  if (parts.some((part) => part === '')) {
    return 'Уберите пустое значение между запятыми';
  }

  if (!limits) return null;

  if (parts.length > limits.maxValuesPerGroup) {
    return `В строке не больше ${limits.maxValuesPerGroup} значений`;
  }

  const tooLongValue = parts.find(
    (part) => part.length > limits.maxValueLength
  );

  return tooLongValue
    ? `Значение «${tooLongValue.slice(0, 20)}…» длиннее ${
        limits.maxValueLength
      } символов`
    : null;
};

// Непустые строки условий. Функция идёт и на каждой перерисовке формы
// (проверка пересечений), а не только после валидации, поэтому терпит
// любые элементы: «Добавить строку» кладёт в список пустое значение.
export const getFilledKeywordGroups = (
  groups: ReadonlyArray<unknown> | null | undefined
): string[] =>
  (Array.isArray(groups) ? groups : [])
    .filter((group): group is string => typeof group === 'string')
    .map((group) => group.trim())
    .filter(Boolean);
